import React from 'react';
import { Colors } from 'library';
import usePublicSessionTracking from 'parent-portal/shared/PublicSessionTracking';
import { HomeHeader } from './components/HomeHeader';
import useTrackingCookies from 'parent-portal/shared/EngagementSourceTracking';
import { useHistory } from 'react-router';

export default function Home() {
    useTrackingCookies('/');
    const { usePageLoadTracking } = usePublicSessionTracking('home');
    const history = useHistory();
    usePageLoadTracking();

    function signUp() {
        history.push('/signup');
    }

    return (
        <div style={{ backgroundColor: Colors.lightTurq, width: '100%' }}>
            <HomeHeader signUp={signUp} />
        </div>
    );
}
